//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import _              from 'lodash';
import { takeLatest } from 'redux-saga/effects';
import { put }        from 'redux-saga/effects';
import { call }       from 'redux-saga/effects';

import * as Api                      from '@api/index';
import { SubscriptionOptionActions } from '@slices/subscriptionOption';

function* fetchSubscriptionOptions() {
    const response = yield call(Api.context.subscriptionOptions.fetchSubscriptionOptions);

    if (response.ok) {
        yield put(SubscriptionOptionActions.fetchSubscriptionOptionsSucceeded({
            subscriptionOptions: _.get(response, 'data.member'),
        }));
    } else {
        yield put(SubscriptionOptionActions.fetchSubscriptionOptionsFailed());
    }
}

const callSagas = () => {
    return [
        // @formatter:off
        takeLatest([SubscriptionOptionActions.fetchSubscriptionOptions().type], fetchSubscriptionOptions),
        // @formatter:on
    ];
};

export default {
    callSagas,
};
